import { Link } from 'react-router-dom';
import { categoryCards } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">动漫分类</h2>
          <p className="mt-1.5 text-sm text-foreground-500">按题材与地区快速找到你感兴趣的作品</p>
        </div>
        <Link to="/category" className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer">
          全部作品
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {categoryCards.map((cat) => (
          <Link
            key={cat.key}
            to={`/category?${cat.filter.field === 'type' ? 'type' : 'region'}=${encodeURIComponent(cat.filter.value)}`}
            className="group flex flex-col gap-3 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 hover:bg-accent-50/50 transition-colors cursor-pointer"
          >
            <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
              <i className={`${cat.icon} text-2xl`}></i>
            </span>
            <div>
              <h3 className="text-sm font-semibold text-foreground-950">{cat.name}</h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed hidden sm:block">{cat.desc}</p>
            </div>
            <span className="mt-auto text-xs text-foreground-400">{cat.count} 部作品</span>
          </Link>
        ))}
      </div>
    </section>
  );
}